import { Fragment, useState, useEffect } from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';

/* MUI */
import { makeStyles } from '@material-ui/core/styles';
import { Container, Tabs, Tab, Typography, CssBaseline } from '@material-ui/core';

/* MobX */
import { observer } from 'mobx-react-lite';

const useStyles = makeStyles((theme) => ({
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 4),
    marginTop: theme.spacing(2),
  },
  wrapper: {
    textTransform: 'initial'
  }
}));

const ReportNavigation = observer(props => {
  const classes = useStyles();
  let navigate = useNavigate();
  let location = useLocation();
  const [selectedTab, setSelectedTab] = useState("/reports/newmapblock");

  useEffect(() => {
    if (location.pathname === "/reports") {
      setSelectedTab("/reports/newmapblock");
    } else {
      setSelectedTab(location.pathname);
    }
  }, [location.pathname])

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    navigate(newValue);
  }

  return (
    <Fragment>
      <CssBaseline />
      <Container maxWidth="lg" className={classes.heroContent} >
        <Typography
          component="h1"
          variant="h2"
          align="center"
          color="textPrimary"
          gutterBottom
        >
          Reports
        </Typography>
        {/* update value for each tabs */}
        <Tabs value={selectedTab} onChange={handleTabChange} centered>
          <Tab label="New Map Block Lots" value="/reports/newmapblock" className={classes.wrapper} />
          <Tab label="Deprecated Map Block Lots" value="/reports/deprecatedmapblock" className={classes.wrapper} />
          <Tab label="New Legal Owners" value="/reports/newlegalowner" className={classes.wrapper} />
          <Tab label="Assessor Block Lots" value="/reports/assessorblock" className={classes.wrapper} />
        </Tabs>
      </Container>
      <Outlet />
    </Fragment>
  )
});

export default ReportNavigation;